import { makeStyles, tokens, mergeClasses } from '@fluentui/react-components';
import { phaseColors } from '../services/theme';

interface Props { step: 1 | 2 | 3 | 4; }

const PHASES = ['STOP', 'THINK', 'ACT', 'REVIEW'] as const;

const useStyles = makeStyles({
  strip: {
    display: 'flex',
    gap: '6px',
    backgroundColor: '#F8FAFD',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: '#E7EDF4',
    paddingTop: '7px',
    paddingBottom: '7px',
    paddingLeft: '12px',
    paddingRight: '12px',
    flexShrink: 0,
  },
  cell: {
    textAlign: 'center',
    flex: 1,
    minHeight: '30px',
    paddingTop: '8px',
    paddingBottom: '8px',
    paddingLeft: '4px',
    paddingRight: '4px',
    borderRadius: '999px',
    fontSize: '10.5px',
    fontWeight: 600,
    letterSpacing: 0,
    color: tokens.colorNeutralForeground4,
    backgroundColor: '#FFFFFF',
    boxShadow: 'inset 0 0 0 1px rgba(17,24,36,0.06)',
  },
  cellLast: {},
  done: { color: '#2E7D32' },
});

export function PhaseStrip({ step }: Props) {
  const styles = useStyles();
  return (
    <div className={styles.strip}>
      {PHASES.map((p, i) => {
        const oneBased = i + 1;
        const isDone = oneBased < step;
        const isActive = oneBased === step;
        const phaseColor = phaseColors[p];
        const cls = mergeClasses(
          styles.cell,
          i === PHASES.length - 1 && styles.cellLast,
          isDone && styles.done,
        );
        return (
          <div
            key={p}
            className={cls}
            style={isActive ? {
              color: '#FFFFFF',
              backgroundColor: phaseColor,
              boxShadow: `0 8px 16px ${phaseColor}24`,
            } : undefined}
          >
            {p}
          </div>
        );
      })}
    </div>
  );
}
